var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.7,
    height: 21.7,
    viewBox: "0 0 17.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(-3.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M18,22.85H6A2.853,2.853,0,0,1,3.15,20V6A2.853,2.853,0,0,1,6,3.15H8a.85.85,0,1,1,0,1.7H6A1.151,1.151,0,0,0,4.85,6V20A1.151,1.151,0,0,0,6,21.15H18A1.151,1.151,0,0,0,19.15,20V6A1.151,1.151,0,0,0,18,4.85H16a.85.85,0,1,1,0-1.7h2A2.853,2.853,0,0,1,20.85,6V20A2.853,2.853,0,0,1,18,22.85Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    d: "M1-.85H7A1.852,1.852,0,0,1,8.85,1V3A1.852,1.852,0,0,1,7,4.85H1A1.852,1.852,0,0,1-.85,3V1A1.852,1.852,0,0,1,1-.85Zm6,4A.15.15,0,0,0,7.15,3V1A.15.15,0,0,0,7,.85H1A.15.15,0,0,0,.85,1V3A.15.15,0,0,0,1,3.15Z",
    transform: "translate(8 2)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.d106370f7f917af76f03ea021f2eaaef.svg";
export { ForwardRef as ReactComponent };